export  const containsSpecialCharacters = (name: string): boolean => {
  const specialCharacters = /[.:"']/;
  return specialCharacters.test(name);
};